import { Extension } from './gestaoExtensions';

/**
 * Extensões de Inteligência Artificial
 * 
 * Lista de extensões relacionadas à integração com IA para potencializar
 * a prática clínica com recursos avançados como sugestões de diagnóstico,
 * transcrição automática e análise de tendências de saúde.
 */
export const iaExtensions: Extension[] = [
  {
    id: "agent-case-discussion",
    title: "Agente de discussão de casos",
    description:
      "O Agente de Discussão de Casos é um assistente clínico especializado que auxilia na análise sistemática de casos clínicos, utilizando inteligência artificial e medicina baseada em evidências. Ele oferece suporte na avaliação de casos simples e complexos, fornecendo insights estruturados e fundamentados em evidências científicas atualizadas, sempre respeitando a autonomia e o julgamento clínico do profissional de saúde.",
    status: "Disponível", // Será atualizado dinamicamente baseado no contrato
    disabled: true,
    priceInfo: "Beta Gratuito",
    plan: {
      id: "ai_integration_plan_001",
      name: "Discussão de casos",
      description:
        "Assistente clínico especializado para análise e discussão de casos baseada em evidências",
      features: [
        "Análise sistemática de casos clínicos simples e complexos",
        "Assistência clínica especializada com IA",
        "Insights estruturados baseados em evidências científicas",
        "Suporte na avaliação e tomada de decisão clínica",
        "Respeito à autonomia e julgamento do profissional",
        "Acesso a evidências científicas atualizadas",
      ],
      auto_recurring: {
        frequency: 1,
        frequency_type: "months",
        transaction_amount: 129.9,
        currency_id: "BRL",
      },
    },
  },
  {
    id: "agent-medical-report",
    title: "Agente de relatórios médicos",
    description:
      "O Agente de Relatórios Médicos é um assistente especializado que auxilia na geração de relatórios médicos personalizados e tecnicamente fundamentados para múltiplas finalidades clínicas, administrativas e jurídicas. Utilizando inteligência artificial, o agente ajuda a criar documentos estruturados seguindo as melhores práticas e requisitos específicos para cada tipo de relatório, incluindo laudos para INSS, escola, curatela, judicialização e outros fins.",
    status: "Disponível", // Será atualizado dinamicamente baseado no contrato
    disabled: true,
    priceInfo: "Beta Gratuito",
    plan: {
      id: "analise_relatorio_plan_001",
      name: "Plano Gerador de Relatórios Médicos",
      description:
        "Assistente especializado para geração de relatórios médicos personalizados e tecnicamente fundamentados",
      features: [
        "Geração de relatórios para múltiplas finalidades (INSS, escola, curatela etc)",
        "Estruturação automática seguindo padrões técnicos",
        "Inclusão automática de CID-10/CID-11 e terminologia médica apropriada",
        "Adaptação de linguagem conforme destinatário",
        "Suporte para justificativas clínicas e legais",
        "Modelos personalizáveis para diferentes tipos de relatório",
      ],
      auto_recurring: {
        frequency: 1,
        frequency_type: "months",
        transaction_amount: 129.9,
        currency_id: "BRL",
      },
    },
  },
  {
    id: "agent-guideline-assistant",
    title: "Agente de Orientações ao paciente",
    description:
      "O Agente de Orientações ao Paciente é um assistente especializado que ajuda profissionais de saúde a criar orientações médicas personalizadas e empáticas. Utilizando uma abordagem centrada na pessoa, gera recomendações claras e motivadoras adaptadas ao contexto individual de cada paciente, considerando aspectos clínicos, emocionais e funcionais específicos.",
    status: "Disponível", // Será atualizado dinamicamente baseado no contrato
    disabled: true,
    priceInfo: "Beta Gratuito",
    plan: {
      id: "orientacoes_paciente_plan_001",
      name: "Plano Orientações ao Paciente",
      description:
        "Assistente especializado para geração de orientações médicas personalizadas e empáticas",
      features: [
        "Orientações personalizadas com linguagem adaptada ao perfil do paciente",
        "Estruturação clara das condutas médicas e metas terapêuticas",
        "Sugestões de hábitos saudáveis alinhados à rotina individual",
        "Abordagem empática e acolhedora na comunicação",
        "Recomendações práticas não-medicamentosas contextualizadas",
        "Reforço do vínculo terapêutico e autonomia do paciente",
      ],
      auto_recurring: {
        frequency: 1,
        frequency_type: "months",
        transaction_amount: 129.9,
        currency_id: "BRL",
      },
    },
  },
  {
    id: "agent-ai-secretary",
    title: "Secretária IA",
    description:
      "A Secretária IA é uma assistente que apoia o funcionamento da clínica via WhatsApp Business.",
    status: "Disponível", // Será atualizado dinamicamente baseado no contrato
    disabled: true,
    priceInfo: "Beta Gratuito",
    plan: {
      id: "secretaria_ia_plan_001",
      name: "Secretária IA",
      description:
        "Assistente de atendimento via WhatsApp Business (Meta) para a clínica",
      features: [
        "Apoio ao atendimento da clínica pelo WhatsApp Business",
        "Funciona somente com canal WhatsApp próprio (Meta) ativo",
        "Não disponível no plano com número padrão Fluxmed",
      ],
      auto_recurring: {
        frequency: 1,
        frequency_type: "months",
        transaction_amount: 129.9,
        currency_id: "BRL",
      },
    },
  },
];
